import React, { FC, useEffect,useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import StyledButton from 'components/Button';
import { Icon } from 'components/Icon';
import SummaryDatePicker from 'components/SummaryDatePicker';
import { BookingOverlay, BookingSummaryContainer, BookingSummarySlot } from '../../style';
import { useRecoilValue, useRecoilState } from 'recoil';
import { selectedRooms } from 'states/CheckOutStates/atoms';
import { dateRangeState, guestQuantityState, roomQuantityState, childrenQuantityState } from 'states/SearchBarStates/atoms';
import AdapterMoment from '@material-ui/pickers/adapter/moment';
import { LocalizationProvider } from '@material-ui/pickers';
import { useGetAvailableRooms } from 'customHooks/useGetAvailableRooms';
import moment from 'moment';
import { DecreaseIcon, IncreaseIcon } from 'assets/icons';
import {
  DEFAULT_CHECK_IN_HOUR,
  DEFAULT_CHECK_IN_MINUTE,
  DEFAULT_CHECK_OUT_HOUR,
  DEFAULT_CHECK_OUT_MINUTE,
  DEFAULT_CUT_OFF_HOUR,
  DEFAULT_CUT_OFF_MINUTE,
  DEFAULT_MAX_DAYS
} from 'constants/constant';
import { dateDiff } from 'utils/util';

import { HST_RATE, MAT_RATE } from 'constants/constant';
import { ReactNode } from 'react';
import { useMobileBookingSummary } from 'customHooks/useMobileBookingSummary';

const debug = false;


const BookingSummary: FC<{ handleContinueBooking: () => void }> = ({ handleContinueBooking }) => {


  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const checkInDateFromURL = params.get('checkInDate')
  const checkOutDateFromURL = params.get('checkOutDate')
  const guestQuantityFromURL = parseInt(params.get('guestQuantity') || '1')
  const roomQuantityFromURL = parseInt(params.get('roomQuantity') || '1')
  const childrenQuantityFromURL = parseInt(params.get('childrenQuantity') || '0')

  const [summaryText, setSummaryText] = useState<ReactNode>(null);

  const persistSelectedRooms = useRecoilValue(selectedRooms);
  const [guestQuantity, setGuestQuantity] = useRecoilState(guestQuantityState);
  const [childrenQuantity, setChildrenQuantity] = useRecoilState(childrenQuantityState);
  const [roomQuantity, setRoomQuantity] = useRecoilState(roomQuantityState);
  const [dateRange, setDateRange] = useRecoilState(dateRangeState);
  // URL values initialize this visit; later edits remain in Recoil.
  const initialSearch = useRef({
    checkInDateFromURL,
    checkOutDateFromURL,
    guestQuantityFromURL,
    roomQuantityFromURL,
    guestQuantity
  });
  const { searchResult } = useGetAvailableRooms()
  const availableRooms = searchResult.find((roomType) => roomType.roomTypeId === persistSelectedRooms.roomTypeId)?.availableRooms || 0

  const nights = dateDiff(new Date(dateRange[0]), new Date(dateRange[1]));
  
  const totalPrice = (persistSelectedRooms.pricePerNight ?? 0) * roomQuantity * nights;
  const MAT = totalPrice * MAT_RATE;

  const HST = (totalPrice + MAT) * HST_RATE;
  const total = totalPrice + MAT + HST;

  const { isOverlay, panelRef, handleRef, slotRef, detailsRef, toggle, close } = useMobileBookingSummary();
  
  localStorage.setItem(
    'childrenQuantity',
    String(Number.isFinite(childrenQuantityFromURL) ? Math.max(0, childrenQuantityFromURL) : 0)
  );

  
  
 
  useEffect (()=> {

    if (debug) {
      console.log ("persistSelectedRooms:", persistSelectedRooms);
    }

    setSummaryText(
      <>
        {persistSelectedRooms.name} - {persistSelectedRooms.bed}
        {persistSelectedRooms.hasWindows
          ? " w/ window"
          : persistSelectedRooms.name === "Bishop Inside"
          ? " no/ window"
          : " w/ skylight"}
        {" " + roomQuantity * nights + " @ $" + persistSelectedRooms.pricePerNight}
      </>
    );

  }, [persistSelectedRooms, nights, roomQuantity])

  useEffect(() => {
    const {
      checkInDateFromURL,
      checkOutDateFromURL,
      guestQuantityFromURL,
      roomQuantityFromURL,
      guestQuantity
    } = initialSearch.current;

    if(checkInDateFromURL && checkOutDateFromURL) {
      const dateRange = [checkInDateFromURL, checkOutDateFromURL]
      if(moment() > moment()
                      .set('hour', DEFAULT_CUT_OFF_HOUR)
                      .set('minute', DEFAULT_CUT_OFF_MINUTE)
                      .set('second', 0)
      ) {
        if(moment(checkInDateFromURL) < moment()) {
          dateRange[0] = moment()
                          .set({ hour: DEFAULT_CHECK_IN_HOUR, minute: DEFAULT_CHECK_IN_MINUTE, second: 0 })
                          .utc()
                          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
        } else if(moment(checkInDateFromURL) > moment()
                                                .add((DEFAULT_MAX_DAYS-1), "days")
                                                .set({ hour: DEFAULT_CHECK_IN_HOUR, minute: DEFAULT_CHECK_IN_MINUTE, second: 0 })
        ) {
          dateRange[0] = moment()
                          .add((DEFAULT_MAX_DAYS-1), "days")
                          .set({ hour: DEFAULT_CHECK_IN_HOUR, minute: DEFAULT_CHECK_IN_MINUTE, second: 0 })
                          .utc()
                          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
        } else {
          dateRange[0] = moment(checkInDateFromURL)
                          .set({ hour: DEFAULT_CHECK_IN_HOUR, minute: DEFAULT_CHECK_IN_MINUTE, second: 0 })
                          .utc()
                          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
        }
        if(moment(checkOutDateFromURL) < moment(checkInDateFromURL)
                                          .add(1, "days")
                                          .set({ hour: DEFAULT_CHECK_OUT_HOUR, minute: DEFAULT_CHECK_OUT_MINUTE, second: 0 })
        ) {
          dateRange[1] = moment(checkInDateFromURL)
                          .add(1, "days")
                          .set({ hour: DEFAULT_CHECK_OUT_HOUR, minute: DEFAULT_CHECK_OUT_MINUTE, second: 0 })
                          .utc()
                          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
        } else if(moment(checkOutDateFromURL) > moment()
                                                  .add(DEFAULT_MAX_DAYS, "days")
                                                  .set({ hour: DEFAULT_CHECK_OUT_HOUR, minute: DEFAULT_CHECK_OUT_MINUTE, second: 0 })
        ) {
          dateRange[1] = moment()
                          .add(DEFAULT_MAX_DAYS, "days")
                          .set({ hour: DEFAULT_CHECK_OUT_HOUR, minute: DEFAULT_CHECK_OUT_MINUTE, second: 0 })
                          .utc()
                          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
        } else {
          dateRange[1] = moment(checkOutDateFromURL)
                          .set({ hour: DEFAULT_CHECK_OUT_HOUR, minute: DEFAULT_CHECK_OUT_MINUTE, second: 0 })
                          .utc()
                          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
        }

      } else {
        if(moment(checkInDateFromURL) < moment()) {
          dateRange[0] = moment()
                          .subtract(1, "days")
                          .set({ hour: DEFAULT_CHECK_IN_HOUR, minute: DEFAULT_CHECK_IN_MINUTE, second: 0 })
                          .utc()
                          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
        } else if(moment(checkInDateFromURL) > moment()
                                                .add((DEFAULT_MAX_DAYS-2), "days")
                                                .set({ hour: DEFAULT_CHECK_IN_HOUR, minute: DEFAULT_CHECK_IN_MINUTE, second: 0 })
        ) {
          dateRange[0] = moment()
                          .add((DEFAULT_MAX_DAYS-2), "days")
                          .set({ hour: DEFAULT_CHECK_IN_HOUR, minute: DEFAULT_CHECK_IN_MINUTE, second: 0 })
                          .utc()
                          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
        } else {
          dateRange[0] = moment(checkInDateFromURL)
                          .set({ hour: DEFAULT_CHECK_IN_HOUR, minute: DEFAULT_CHECK_IN_MINUTE, second: 0 })
                          .utc()
                          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
        }
        if(moment(checkOutDateFromURL) < moment(checkInDateFromURL)
                                          .set({ hour: DEFAULT_CHECK_OUT_HOUR, minute: DEFAULT_CHECK_OUT_MINUTE, second: 0 })
        ) {
          dateRange[1] = moment(checkInDateFromURL)
            .set({ hour: DEFAULT_CHECK_OUT_HOUR, minute: DEFAULT_CHECK_OUT_MINUTE, second: 0 })
            .utc()
            .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
        } else if(moment(checkOutDateFromURL) > moment()
                                                  .add((DEFAULT_MAX_DAYS-1), "days")
                                                  .set({ hour: DEFAULT_CHECK_OUT_HOUR, minute: DEFAULT_CHECK_OUT_MINUTE, second: 0 })
        ) {
          dateRange[1] = moment()
                          .add((DEFAULT_MAX_DAYS-1), "days")
                          .set({ hour: DEFAULT_CHECK_OUT_HOUR, minute: DEFAULT_CHECK_OUT_MINUTE, second: 0 })
                          .utc()
                          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
        } else {
          dateRange[1] = moment(checkOutDateFromURL)
                          .set({ hour: DEFAULT_CHECK_OUT_HOUR, minute: DEFAULT_CHECK_OUT_MINUTE, second: 0 })
                          .utc()
                          .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
        }
      }
      localStorage.setItem('dateRange', JSON.stringify(dateRange));
      setDateRange(dateRange);
    }

    if(guestQuantityFromURL > 18) {
      localStorage.setItem('guestQuantity', '18');
      setGuestQuantity(18);
    } else if((guestQuantityFromURL >= 1) && (guestQuantityFromURL <= 18)) {
      localStorage.setItem('guestQuantity', guestQuantityFromURL + '');
      setGuestQuantity(guestQuantityFromURL);
    } else {
      localStorage.setItem('guestQuantity', '1');
      setGuestQuantity(1);
    }

    if(roomQuantityFromURL > Math.min(guestQuantityFromURL, 9)) {
      localStorage.setItem('roomQuantity', Math.min(guestQuantityFromURL, 9) + '');
      setRoomQuantity(Math.min(guestQuantityFromURL, 9));
    } else if((roomQuantityFromURL >= guestQuantityFromURL/2) && (roomQuantityFromURL <= Math.min(guestQuantityFromURL, 9))) {
      localStorage.setItem('roomQuantity', roomQuantityFromURL + '');
      setRoomQuantity(roomQuantityFromURL);
    } else {
      localStorage.setItem('roomQuantity', Math.ceil(guestQuantity/2) + '');
      setRoomQuantity(Math.ceil(guestQuantity/2));
    }
  }, [setDateRange, setGuestQuantity, setRoomQuantity])


  return (
    <>
      <BookingOverlay
    className={isOverlay ? 'visible' : ''}
    onClick={close}
    />
    
    <BookingSummarySlot ref={slotRef} className={isOverlay ? 'reserved' : ''} aria-hidden="true" />
    <BookingSummaryContainer ref={panelRef} className={`mobileFlowSummary ${isOverlay ? 'summaryOverlay' : ''}`}>
      <div
        className="swipeToHide"
        ref={handleRef}
        role="button"
        tabIndex={0}
        aria-expanded={isOverlay}
        onClick={toggle}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggle();
          }
        }}
      >
      {isOverlay ? 'Tap here to hide details' : 'Tap here to show details'}
        <div className="swipeToHideHr"></div>
      </div>

      <div className="bookingMobileContentDetails" ref={detailsRef}>

        <div className="title flowSummaryTitle">Your booking summary</div>
        <div className="bookingDates">
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <SummaryDatePicker label="DATES" dateRange={dateRange}/>
          </LocalizationProvider>
        </div>
        <div className="guestOption guestOptionCount">
          <div className="text">
            <div className="optionTitle">GUESTS</div>
            <div className="optionDescription">How many people are travelling?</div>
          </div>
        </div>
        <div className="guestOption guestOptionAdults">
          <div className="text">
            Adults
          </div>
          <div className='optionButtons'>
            <Icon width={30} height={30}>
              <DecreaseIcon
                className={guestQuantity <= 1? "disabled": ""}
                onClick={() => {
                  if(guestQuantity > 1) {
                    localStorage.setItem('guestQuantity', (guestQuantity - 1).toString());
                    setGuestQuantity(guestQuantity - 1);
                    if(roomQuantity > guestQuantity - 1) {
                      localStorage.setItem('roomQuantity', (guestQuantity - 1).toString());
                      setRoomQuantity(guestQuantity - 1);
                    }
                  }
                }} 
              />
            </Icon>
            <div className='quantity'>{guestQuantity}</div>
            <Icon width={30} height={30}>
              <IncreaseIcon
                className={guestQuantity >= (availableRooms>0? 2 * Math.min(availableRooms, 9): 9) ? "disabled": ""}
                onClick={() => {
                  if(guestQuantity < (availableRooms>0? 2 * Math.min(availableRooms, 9): 9)) {
                    localStorage.setItem('guestQuantity', (guestQuantity + 1).toString());
                    setGuestQuantity(guestQuantity + 1);
                    if(roomQuantity < Math.ceil((guestQuantity+1)/2)) {
                      localStorage.setItem('roomQuantity', Math.ceil((guestQuantity+1)/2).toString());
                      setRoomQuantity(Math.ceil((guestQuantity+1)/2));
                    }
                  }
                }} 
              />
            </Icon>
          </div>
        </div>
        <div className="guestOption guestOptionChildren">
          <div className="text">
            Children
          </div>
          <div className='optionButtons'>
            <Icon width={30} height={30}>
              <DecreaseIcon
                className={childrenQuantity <= 0 ? "disabled": ""}
                onClick={() => {
                  if(childrenQuantity > 0) {
                    localStorage.setItem('childrenQuantity', (childrenQuantity - 1).toString());
                    setChildrenQuantity(childrenQuantity - 1);
                  }
                }} 
              />
            </Icon>
            <div className='quantity'>{childrenQuantity}</div>
            <Icon width={30} height={30}>
              <IncreaseIcon
                onClick={() => {
                    localStorage.setItem('childrenQuantity', (childrenQuantity + 1).toString());
                    setChildrenQuantity(childrenQuantity + 1);
                }} 
              />
            </Icon>
          </div>
        </div>
        <div className="roomOption">
          <div className="text">
            <div className="optionTitle">ROOMS</div>
            <div className="optionDescription">Max 2 guests per room</div>
          </div>
          <div className='optionButtons'>
            <Icon width={30} height={30}>
              <DecreaseIcon
                className={roomQuantity <= Math.ceil(guestQuantity/2)? "disabled": ""}
                onClick={() => {
                  if(roomQuantity > Math.ceil(guestQuantity/2)) {
                    localStorage.setItem('roomQuantity', (roomQuantity - 1).toString());
                    setRoomQuantity(roomQuantity - 1);
                  }
                }} 
              />
            </Icon>
            <div className='quantity'>{roomQuantity}</div>
            <Icon width={30} height={30}>
              <IncreaseIcon
                className={roomQuantity >= (availableRooms>0? Math.min(availableRooms, 9): 9)? "disabled": ""}
                onClick={() => {
                  if(roomQuantity < (availableRooms>0? Math.min(availableRooms, 9): 9)) {
                    localStorage.setItem('roomQuantity', (roomQuantity + 1).toString());
                    setRoomQuantity(roomQuantity + 1);
                    if(roomQuantity===guestQuantity) {
                      localStorage.setItem('guestQuantity', (guestQuantity + 1).toString());
                      setGuestQuantity(guestQuantity + 1);
                    }
                  }
                }} 
              />
            </Icon>
          </div>
        </div>
        {guestQuantity > roomQuantity && (
        <div className="note">
          <span>Note:</span> all of our rooms have one bed, <b>you have selected 2 guests in one room</b>, please be aware that they will be sharing one bed. If you need separate beds please increase the number of rooms.
          {/* <span>Note:</span> all of our rooms have one bed, <b>you have selected 2 guests in one room</b>, please be aware that they will be sharing a one bed. If you need separate beds please increase the number of rooms. */}
        </div>
        )}
        <div className="separatorNoline"></div>
        <div className="booking">BREAKDOWN</div>
        <table cellPadding={0} cellSpacing={0} border={0} className="breakdownTable">
          <tr>
            <td className="totalsRN">{roomQuantity} {roomQuantity === 1 ? 'Room' : 'Rooms'} – {nights} {nights === 1 ? 'Night' : 'Nights'}</td>
            <td></td>
          </tr>
          <tr>
            <td className="line">
              <span className="label">{summaryText}</span>
              <span className="dots"></span>
            </td>
            <td className="price">
            ${totalPrice.toLocaleString('en-CA', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}
            </td>
          </tr>
          <tr>
            <td className="line">
              <span className="label">Municipal Accommodation Tax (6%)</span>
              <span className="dots"></span>
            </td>
            <td className="price">
            ${MAT.toLocaleString('en-CA', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}
            </td>
          </tr>
          <tr>
            <td className="line">
              <span className="label">HST (13%)</span>
              <span className="dots"></span>
            </td>
            <td className="price">
            ${HST.toLocaleString('en-CA', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}
            </td>
          </tr>
          <tr>
            <td className="total">TOTAL</td>
            <td className="total price">
              ${total.toLocaleString('en-CA', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}
              </td>
          </tr>
        </table>
        {/* <div className="priceDetails">
          <span className='text'>{persistSelectedRooms.name?.toUpperCase()}</span>
          <span className='price'>{` CAD ${persistSelectedRooms.pricePerNight?.toFixed(2)} / night`}</span>
        </div> */}


        </div>

        <div className="controls">
        <div className="mobileTotals">
          <div className="closedContent">
          <div className="mobileTotalsTotal">Total <span>
            ${total.toLocaleString('en-CA', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}
            </span></div>
          <div className="mobileTotalsGuests">Guests/Rooms <span>{guestQuantity}/{roomQuantity}</span></div>
          </div>
        </div>
          <div className="controlsButton">
        <StyledButton
          className="nextButton"
          height="48px"
          padding ="0 24px"
          fontSize={16}
          onClick={handleContinueBooking}
          disabled={!persistSelectedRooms.roomTypeId || dateRange[0] === null || dateRange[1] === null}
        >
          Next Step
        </StyledButton>
        </div>
        </div>
      
    </BookingSummaryContainer>
    </>
  )
}

export default BookingSummary